import type { FloatLabelType } from '@angular/material/form-field';

/**
 * Densidades compartidas por los filter fields (toolbar): `app-filter-text-field`, `app-filter-select-field`.
 * Convive en esta carpeta de familia (no en `library/inputs`) — ver R16 en `docs/UI_INVENTORY.md`.
 */
export type MunilyFilterFieldSize = 'large' | 'small';

export const MUNILY_FILTER_FIELD_SIZES: readonly MunilyFilterFieldSize[] = ['large', 'small'];

export const MUNILY_FILTER_FIELD_DEFAULT_SIZE: MunilyFilterFieldSize = 'large';

export const MUNILY_FILTER_FIELD_DEFAULT_FLOAT_LABEL: FloatLabelType = 'auto';
